import { queryOptions } from '@tanstack/react-query';

import type { AssetSensor } from '@/common/asset-sensor';
import { ROLE } from '@/common/role';
import { usePermission } from '@/hooks/use-permission';
import { checkAssetIdIsValid } from '@/lib/utils/asset';
import { axios } from '@/lib/utils/axios';

import { getResponse } from '../../common';
import { API_URLS } from '../../query.client';

export type AssetSensorListSuccessResponse = {
	sensors: AssetSensor[];
};

async function getListAssetSensors(assetId: string): Promise<AssetSensorListSuccessResponse | null> {
	const response = await axios.get(`${API_URLS.ASSETS.SENSORS.INDEX(assetId)}`);
	return getResponse<AssetSensorListSuccessResponse>(response.data);
}

export const useQueryListAssetSensorsOptions = (assetId: string, enabled = true) => {
	const shouldReadSensors = usePermission(ROLE.SENSORS_READ);
	const isValidAssetId = checkAssetIdIsValid(assetId);
	return queryOptions({
		queryKey: ['assets', assetId, 'sensors'],
		queryFn: () => getListAssetSensors(assetId),
		enabled: enabled && isValidAssetId && shouldReadSensors,
	});
};
